(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero2"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSlider(el) {
      var slides = el.querySelectorAll('[data-slide]');
      var dots = el.querySelectorAll('[data-dot]');
      if (slides.length <= 1) return;

      var current = 0;
      var interval = parseInt(el.dataset.slideInterval || '5000', 10);
      var timer;

      function goTo(index) {
        slides[current].classList.remove('hero-slider__slide--active');
        if (dots[current]) dots[current].classList.remove('hero-slider__dot--active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('hero-slider__slide--active');
        if (dots[current]) dots[current].classList.add('hero-slider__dot--active');
      }

      function start() { timer = setInterval(function() { goTo(current + 1); }, interval); }
      function reset() { clearInterval(timer); start(); }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          goTo(parseInt(dot.dataset.dot, 10));
          reset();
        });
      });

      start();
    }

    document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
